import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";
import InnerHeader from "component/shared/innerheader/InnerHeader";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import ChevronIcon from "svg-icons/chevron-icon";
import { useDataVisualizationData } from "./useDataVisualizationData";
import SubjectNav from "./components/SubjectNav";
import VisualizationHeader from "./components/VisualizationHeader";
import VisualizationWorkspace from "./components/VisualizationWorkspace";
import ExportSection from "./components/ExportSection";

function DataVisualization() {
  const intl = useIntl();
  const {
    dir,
    currentLocale,
    isLoading,
    show,
    setShow,
    mainId,
    subSubjectId,
    indicatorIdData,
    setIndicatorIdData,
    indicatorRefs,
    elementPdf,
    mainList,
    subSubjectsListWithMainId,
    indicatorsList,
    indicatorList,
    selectedIndicator,
    indicatorData,
    listOfCheckBox,
    checkboxOptions,
    selectedIndicators,
    allChartData,
    colHeaders,
    visualizationDetails,
    visualization,
    indicatorPublication,
    getChecked,
    handleCheckedChange,
    handleSelectAll,
    handleMainSubjectChange,
    handleSubSubjectChange,
    handleIndicatorChange,
    handleDirFixedBar,
    handleDirContentFixedBar,
    tableExportFilename,
    tableExportTitle,
    hasExportableData,
    handleChartPdfExport,
    handleChartPngExport,
    handleChartJpegExport,
    excelImage,
  } = useDataVisualizationData();

  const subjectNavProps = {
    dir,
    currentLocale,
    mainId,
    subSubjectId,
    indicatorIdData,
    mainList,
    subSubjectsListWithMainId,
    indicatorsList,
    indicatorList,
    indicatorRefs,
    onMainSubjectChange: handleMainSubjectChange,
    onSubSubjectChange: handleSubSubjectChange,
    onIndicatorChange: handleIndicatorChange,
    onIndicatorRadioChange: setIndicatorIdData,
  };

  return (
    <ContentLoading isLoading={isLoading}>
      <div className="data-visualization">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "data" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "data-visualization" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "data-title" })}
          route={"../../data"}
        />
        <div className="container mt-4 mb-5 position-relative overflow-hidden">
          <div className={`fixed-sidebar ${dir === "rtl" ? "r-dir" : "l-dir"}`}>
            <div className="show-icon" onClick={handleDirFixedBar}>
              <Button className={`${dir === "rtl" ? "r-dir" : "l-dir"} `}>
                <ChevronIcon />
              </Button>
            </div>
            <SubjectNav {...subjectNavProps} />
          </div>

          <div className="row gx-lg-2 gx-0 gy-0">
            <div className="col-xl-3 col-lg-4">
              <SubjectNav
                {...subjectNavProps}
                className="sidebar-data-visualization"
              />
            </div>
            <div className="col-xl-9 col-lg-8">
              <div className="content-data-visualization">
                <VisualizationHeader
                  selectedIndicator={selectedIndicator}
                  show={show}
                  onShowChange={setShow}
                />
                <VisualizationWorkspace
                  dir={dir}
                  currentLocale={currentLocale}
                  show={show}
                  elementPdf={elementPdf}
                  allChartData={allChartData}
                  colHeaders={colHeaders}
                  selectedIndicators={selectedIndicators}
                  visualization={visualization}
                  visualizationDetails={visualizationDetails}
                  indicatorPublication={indicatorPublication}
                  indicatorData={indicatorData}
                  selectedIndicator={selectedIndicator}
                  listOfCheckBox={listOfCheckBox}
                  checkboxOptions={checkboxOptions}
                  getChecked={getChecked}
                  onCheckedChange={handleCheckedChange}
                  onSelectAll={handleSelectAll}
                  onToggleContentSidebar={handleDirContentFixedBar}
                />
                <ExportSection
                  dir={dir}
                  show={show}
                  colHeaders={colHeaders}
                  allChartData={allChartData}
                  yearType={visualization?.yearTypeId}
                  currentLocale={currentLocale}
                  tableExportFilename={tableExportFilename}
                  tableExportTitle={tableExportTitle}
                  excelImage={excelImage}
                  hasExportableData={hasExportableData}
                  onExportPdf={handleChartPdfExport}
                  onExportPng={handleChartPngExport}
                  onExportJpeg={handleChartJpegExport}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default DataVisualization;
